import { EventEmitter } from "eventemitter3";

const Loading = `
<div>Loading...</div>
`;
export class ConnectingScreen extends EventEmitter {
  constructor() {
    super();
  }

  public addEventListeners() {}

  public removeEventListeners() {}

  getElement() {
    return Loading;
  }
}
